module.exports = __webpack_public_path__ + "assets/img/env_monitor.64ad60f4.png";